import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api`,
  headers: {
    "Content-Type": "application/json",
    "key": "THUNDER1WoV5UbrGPq5iOXS2SS4ODR9999",
  },
});

// เพิ่ม Authorization token สำหรับ /app/* routes (verifyToken)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
